// The whole code is copied from VPC.

import { DataPointsApiResponse } from '@tableau/metrics-engine';
import { AppState } from '../../app/state/AppState';
import { Loadable, LoadingStatus } from '../models/Loadable';
import { SearchResultItem } from '../models/SearchResultTypes';
import { LoadableDataPointsById } from '../state/MetricsDataState';

export const getLoadableData = (state: LoadableDataPointsById, id: string): Loadable<DataPointsApiResponse> => {
  const model = state[id] as Loadable<DataPointsApiResponse>;

  return model || Loadable.notLoaded;
};

export const getMetricsDataPoints = (state: AppState): LoadableDataPointsById => {
  return state.metricsData.dataPointsById;
};

export function selectMetricDataForMetricId(state: AppState, id: string): DataPointsApiResponse | undefined {
  const loadableContent = getLoadableData(getMetricsDataPoints(state), id);
  if (loadableContent.loadingStatus === LoadingStatus.LOADED) {
    return loadableContent.content;
  }

  return undefined;
}

export function selectMetricDataForContentItem(state: AppState, content: SearchResultItem): DataPointsApiResponse | undefined {
  if (!content) {
    return undefined;
  }

  return selectMetricDataForMetricId(state, content.id);
}

export const notLoadedData = (state: LoadableDataPointsById, ids: ReadonlyArray<string>): ReadonlyArray<string> => {
  return ids
    .map((id) => ({ id, loadable: getLoadableData(state, id) }))
    .filter((item) => item.loadable.loadingStatus === LoadingStatus.NOT_LOADED)
    .map((item) => item.id);
};
